<template>
  <div class="home">
    <banner :prop-list="bannerList" />
    <recentnews />

    <overview />
    <aboutus />
    


    

    <div class="xiabiao">
      <div class="shangbiao">
        <div class="service"><img src="../assets/images/service.png" alt=""></div>
        <ul class="reason clearfix">
          <li
            v-for="(item,i) in list"
            :key="i"
            class="fl"
          >
            {{ item.text }}
            <img
              :src="item.image"
              class="reasonIMG"
            >
          </li>
        </ul>
      </div>
      <div class="xiab">
        <div class="yqlj">
          <HT text="yqlj" />
          <ul
            class="clearfix"
            style="margin-top:68px;margin-bottom:15px;"
          >
            <li
              class="fl"
              v-for="(item,i) in friendList"
              :key="i"
              style="width:25%;text-align:center;cursor:pointer"
            >
              <a
                :href="item.route"
                target="_blank"
              >
                <img
                  :src="item.url"
                  style="width:75%;height:43px;"
                ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '../components/banner.vue'
import HT from '../components/h2.vue'
import { request } from '../assets/utils/request'

import recentnews from '../views/index/recentnews.vue';
import overview from "../views/index/overview.vue";
import aboutus from "../views/index/aboutus.vue";

export default {
    data() {
      return {
        isShow: 'content3',
        list: [],
        activeIndex: '3',
        news: [],
        newsList: [],
        flfg:[],
        industryInformation: [],
        FoodBusiness:false,
        gsp:false,
        internetmedicine:false,
        medicaldevice:false,
        secondclass:false,
        tradingcertificate:false,
        certificate_src: '',
        bannerList: [
          {
          "id": "1",
          "url": "http://www.goodyiyao.com/img/bar1.6ba24b17.jpg"
        },
          {
          "id": "2",
          "url": "http://www.goodyiyao.com/img/bar2_2.27ac98ed.png"
        },
          {
          "id": "3",
          "url": "http://www.goodyiyao.com/img/bar3_1.7daeaea6.png"
        },{
            "id": "4",
            "url": "http://www.goodyiyao.com/img/bar4.948e4c38.jpg"
        },{
            "id": "5",
            "url": "http://www.goodyiyao.com/img/bar5.41a0c283.jpg"
          }
        ],
        friendList: [{
          "id": "1",
          "url": "/images/friend1.jpg",
          "route": "http://mpa.zj.gov.cn/"
        },{
          "id": "2",
          "url": "/images/friend2.jpg",
          "route": "http://www.nhc.gov.cn/"
        },{
          "id": "3",
          "url": "/images/friend3.jpg",
          "route": "http://www.zjwjw.gov.cn/"
        },{
          "id": "4",
          "url": "/images/friend4.jpg",
          "route": "http://www.samr.gov.cn/"
        }]
      }
    },
    components: {
      HT,recentnews,overview,aboutus,banner
    },
  methods: {
      getList: function() {
            var that = this;
            request('/mocks/iconList.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.list = data
                    } catch (e) {
                        that.news = [];
                    }
                }
            })
        },
        handleSelect(key) {
          if(key == 1){
            this.$data.activeIndex = "1"
          }else if(key ==2){
            this.$data.activeIndex = "2"
          }
        },
        handleSelect2(key){
          this.$data.isShow = "content" + key
        },
        getNews: function() {
            var that = this;
            request('/mocks/news/gsggxq.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.news = data
                    } catch (e) {
                        that.news = [];
                    }
                }
            })
        },
        getNewList() {
          var that = this;
            request('/mocks/news/qyxw.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        let mdata = data.filter(item => {return item.id <= 5})
                        that.newsList = mdata
                    } catch (e) {
                        that.newsList = [];
                    }
                }
            })
        },
        routerNews(key) {
          this.$router.push({path:'news',query:{id:key}})
        },
        getflfg() {
          var that = this;
            request('/mocks/news/flfgxq.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        let mdata = data.filter(item => {return item.id <= 5})
                        that.flfg = mdata
                    } catch (e) {
                        that.flfg = [];
                    }
                }
            })
        },
        more() {
          if(this.isShow == "content1") {
            this.$router.push('/news/qyxw')
          }else if(this.isShow == "content2") {
            this.$router.push('/news/hyxw')
          }else{
            this.$router.push('/news/flfg')
          }
        }
    },
    mounted() {
      this.getList();
      this.getNews();
      this.getNewList();
      this.getflfg()
  }
}
</script>

<style scoped>
    .reason{
      justify-content: center;
      align-items: center;
      max-width: 1000px;
      height: auto;
      flex-wrap: wrap;
      font-size: 20px;
      gap: 100px;
      display: flex;
      row-gap: 30px;
      padding-top: 30px;
    }
    .reason>li{
      width: 110px;
      height:110px;
      border: 3px solid #033f85;
      border-radius: 136px;
      font-size: 1rem;
      display: flex;
      flex-direction: column;
      /* justify-content:flex-end; */
      position: relative;
      text-align: center;
      line-height: 260px;
      
    }
    .reasonIMG{
      display: flex;
      top: 50%;
      left:50%;
      transform: translate(-50%,-50%);
      position: absolute;
      max-width: 60%;
      height: 50%;
    }

    .xiabiao{
      height: auto;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
    }
    .shangbiao{
      display: flex;
      flex-direction: column;
      max-width: 100%;
      min-height: 400px;
      justify-content: center;
      align-items: center;
    } 
    .xiab{
      padding-top: 5%;
      max-width: 100%;
    }
    /* 新 */
    .yqlj{
      max-width: 1100px;
      margin: 0 auto;
      flex-wrap: wrap;
    }
    @media (max-width: 1200px){
      .service{
        
    }
    }
</style>